<template>
  <div id="dashboard" class="dash">
    <div class="dash-grid">
      <section class="dash-card">
        <header class="dash-card-header">
          <span class="dash-icon dash-icon--users">
            <i class="fa fa-users" aria-hidden="true" />
          </span>
          <div class="dash-card-text">
            <h3 class="dash-card-title">App Users</h3>
            <p class="dash-card-sub">Active in the last 30 days</p>
          </div>
        </header>
        <div class="dash-chart-wrap">
          <DonutChart class="dash-chart" />
        </div>
      </section>

      <section class="dash-card">
        <header class="dash-card-header">
          <span class="dash-icon dash-icon--devices">
            <i class="fa fa-microchip" aria-hidden="true" />
          </span>
          <div class="dash-card-text">
            <h3 class="dash-card-title">Devices</h3>
            <p class="dash-card-sub">Reporting in the last 30 days</p>
          </div>
        </header>
        <div class="dash-chart-wrap">
          <DonutChart2 class="dash-chart" />
        </div>
      </section>

      <section class="dash-card">
        <header class="dash-card-header">
          <span class="dash-icon dash-icon--glucose">
            <i class="fa fa-tint" aria-hidden="true" />
          </span>
          <div class="dash-card-text">
            <h3 class="dash-card-title">Glucose Readings</h3>
            <p class="dash-card-sub">Distribution across default zones</p>
          </div>
        </header>
        <div class="dash-chart-wrap">
          <DonutGlucoseZones class="dash-chart" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import DonutChart from "@/components/DonutChart.vue";
import DonutChart2 from "@/components/DonutChart2.vue";
import DonutGlucoseZones from "@/components/DonutGlucoseZones.vue";

export default {
  components: { DonutChart, DonutChart2, DonutGlucoseZones },
};
</script>

<style scoped>
.dash {
  width: 100%;
}
.dash-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.25rem;
}
.dash-card {
  background: #ffffff;
  border: 1px solid #e6e8ee;
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.dash-card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.dash-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  font-size: 1rem;
  color: #ffffff;
  flex-shrink: 0;
}
.dash-icon--users {
  background: #2a345d;
}
.dash-icon--devices {
  background: #4a6491;
}
.dash-icon--glucose {
  background: #b02a37;
}
.dash-card-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.dash-card-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #1f2540;
}
.dash-card-sub {
  margin: 0;
  font-size: 0.78rem;
  color: #6b7383;
  font-weight: 500;
}
.dash-chart-wrap {
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
